// This component provides individual dropzone
// Each Dropzone can have allowed number of cards.
// Cards can be moved between dropzones & also sorted within a dropzone
import { useEffect, useState } from 'react';
import {
  editChartPropItem,
  updateIsAutoFilterEnabledPropLeft,
  updateFilterAnyContidionMatchPropLeft,
  setMeasureAxisFields,
  deleteItemInChartProp,
  moveItemChartProp,
  setOldChartType,
  changeGeoMapUnMatched,
} from '../../../redux/ChartPoperties/ChartPropertiesActions';
import {
  toggleFilterRunState,
  clearDropZoneFieldsChartPropLeft,
} from '../../../redux/ChartPoperties/ChartPropertiesActions';
import { updateDynamicMeasureAxes } from '../../../redux/DynamicMeasures/DynamicMeasuresActions';
import { useDrop } from 'react-dnd';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
import {
  fieldName,
  findNewDisplayName,
  getRoundingDigits,
} from '../../CommonFunctions/CommonFunctions';
import ChartsInfo from '../ChartsInfo2';
import { setPrefix } from '../SetPrefix';
import { setDisplayName } from '../setDisplayName';
import { Menu, MenuItem, Divider, useTheme, Radio, Tooltip } from '@mui/material';
import { AlertColor } from '@mui/material/Alert';
import InfoOutlineSharpIcon from '@mui/icons-material/InfoOutlineSharp';
import { editChartPropItemForDm } from '../../../redux/DynamicMeasures/DynamicMeasuresActions';
import Logger from '../../../Logger';
import { fontSize } from '../../../';
import {
  addOrEditSimplecardConditionalFormat,
  callQueryAPI,
  deleteTablecf,
  deleteSortConfiguration,
  SetModifyOptions,
  updateAxisOptions,
  updateFormatOption,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { SortConfiguration } from '../../../redux/ChartPoperties/ChartControlsInterface';
import { Area, AxisType, DropTo, messages } from '../../CommonFunctions/aliases';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from '../../../redux';
import SnackBar from '../../SnackBar';
import DropZoneHeader from './DropZoneHeader';
import ChartFilterCards from './ChartFilterCards';
import ChartAxesCards from './ChartAxesCards';
import ShortUniqueId from 'short-unique-id';
import { handleCheckDisableField } from '../../ChartOptions/Sort/reusableFunctions';

interface DropZoneProps {
  bIndex: number;
  name: string;
  propKey: string;
  uID?: string;
  tabTileProps: any;
  chartProp: any;
  lastAxisName: string;
}

const DropZone = ({
  bIndex,
  name,
  propKey,
  uID,
  tabTileProps,
  chartProp,
  lastAxisName,
}: DropZoneProps) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const {
    calculations,
    chartControls,
    dynamicMeasureState,
    axisOptions,
    sortConfigurations,
    checkedMeasure,
  } = useSelector((state: RootState) => ({
    calculations: state.calculations,
    chartControls: state.chartControls,
    dynamicMeasureState: state.dynamicMeasuresState,
    axisOptions: state.chartControls.properties[propKey].axisOptions,
    sortConfigurations: state.chartControls.properties[propKey].sortConfigurations || [],
    checkedMeasure:
      state.chartControls.properties[propKey]?.formatOptions?.tooltipFormats?.checkedMeasure || [],
  }));

  const [severity, setSeverity] = useState<AlertColor>('success');
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>('Testing alert');
  const [isFilterCollapsed, setIsFilterCollapsed] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showBorder, setShowBorder] = useState(false);

  const theme = useTheme();
  let currentChartAxesName = uID ? 'chartAxes_' + uID : 'chartAxes';

  let chatAxesFieldsLength =
    chartProp.properties[propKey][currentChartAxesName][bIndex]?.fields.length;

  const selectedDynamicMeasureProps =
    dynamicMeasureState?.dynamicMeasureProps?.[dynamicMeasureState.selectedTabId]?.[
    dynamicMeasureState.selectedTileId
    ]?.[`${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`];

  const uIdGenerator = () => {
    const uId = new ShortUniqueId({ length: 4 });
    return uId();
  };

  let currentChartAxes = chartProp.properties[propKey][currentChartAxesName];

  // This function deletes sort config when new field takes place of a old field having sort. By checking allowed numbers.
  const deleteReplacedFieldSortConfig = (binIndex: number, allowedNumbers: number) => {
    const fields = currentChartAxes[binIndex]?.fields || [];
    if (fields.length >= allowedNumbers && fields[0]?.uId) {
      const configIndex = sortConfigurations.findIndex(
        (config: SortConfiguration) => config.fieldId === fields[0].uId,
      );
      if (configIndex !== -1) {
        dispatch(deleteSortConfiguration(propKey, configIndex));
      }
    }
  };

  const updateRollUp = () => {
    let currentAxesFields = currentChartAxes[bIndex]?.fields;
    if (
      ['crossTab', 'heatmap', 'boxPlot', 'bubbleMap'].includes(
        chartProp.properties[propKey].chartType,
      )
    ) {
      let rollupDimentionOneFieldIndex = chartProp.properties[propKey][
        currentChartAxesName
      ][1].fields.findIndex((field: any) => field.rollupDepth);
      let rollupDimentionTwoFieldIndex: any = chartProp.properties[propKey][
        currentChartAxesName
      ][2].fields.findIndex((field: any) => field.rollupDepth);

      if (uID) {
        if (rollupDimentionOneFieldIndex > -1 || rollupDimentionTwoFieldIndex > -1) {
          let isManualDimentionOne = chartProp.properties[propKey][
            currentChartAxesName
          ][1].fields.find((field: any) => field.isManual);
          let isManualDimentionTwo = chartProp.properties[propKey][
            currentChartAxesName
          ][2].fields.find((field: any) => field.isManual);

          if (!isManualDimentionOne && !isManualDimentionTwo) {
            if (rollupDimentionOneFieldIndex > -1) {
              updateField(1, rollupDimentionOneFieldIndex, false);
              updateField(
                2,
                chartProp.properties[propKey][currentChartAxesName][2].fields?.length - 1,
                true,
              );
            } else {
              updateField(2, rollupDimentionTwoFieldIndex, false);
              updateField(
                2,
                chartProp.properties[propKey][currentChartAxesName][2].fields?.length - 1,
                true,
              );
            }
          }
        } else {
          if (chartProp.properties[propKey][currentChartAxesName][2].fields?.length > 0) {
            updateField(
              2,
              chartProp.properties[propKey][currentChartAxesName][2].fields?.length - 1,
              true,
            );
          } else {
            updateField(
              1,
              chartProp.properties[propKey][currentChartAxesName][1].fields?.length - 1,
              true,
            );
          }
        }
      }
    } else {
      let rollupFieldIndex = chartProp.properties[propKey][currentChartAxesName]?.[
        bIndex
      ]?.fields?.findIndex((field: any) => field?.rollupDepth);

      if (uID) {
        if (rollupFieldIndex > -1) {
          let isManual = chartProp.properties[propKey][currentChartAxesName][bIndex].fields.find(
            (field: any) => field.isManual,
          );

          if (!isManual) {
            updateField(bIndex, rollupFieldIndex, false);
            updateField(bIndex, currentAxesFields?.length - 1, true);
          }
        } else {
          updateField(bIndex, rollupFieldIndex, false);
          updateField(bIndex, currentAxesFields?.length - 1, true);
        }
      }
    }

    function updateField(binIndex: number, index: number, enable: boolean) {
      let _field = chartProp.properties[propKey][currentChartAxesName][binIndex].fields[index];

      if (_field) {
        let _tempField = JSON.parse(JSON.stringify(_field));

        if (_tempField) {
          _tempField.rollupDepth = enable;
          dispatch(
            editChartPropItem('updateQuery', {
              propKey,
              binIndex,
              itemIndex: index,
              item: _tempField,
              currentChartAxesName,
            }),
          );
        }
      }
    }
  };
  const getAllMeasureFieldsGroupBy = () => {
    const axes = chartProp.properties[propKey]?.chartAxes || [];

    const targetAxes = [AxisType.Measure, AxisType.X, AxisType.Y];

    const grouped: Record<string, any[]> = {};

    targetAxes.forEach((axisName) => {
      const axis = axes.find((a: any) => a.name === axisName);
      grouped[axisName] = axis?.fields ?? [];
    });

    return grouped;
  };
  const chartType = chartProp.properties[propKey].chartType;

  //--- Monitors Split By fields and convert Min/Max/Count Unique to Sum when Split By has fields---//
  useEffect(() => {
    if (chartType !== 'bubbleMap' || uID) return;
    // This will run only run for bubble map
    const splitByAxis = chartProp.properties[propKey].chartAxes.find(
      (axis: any) => axis.name === 'Split By',
    );

    // Only convert if Split By has fields
    if (!splitByAxis?.fields?.length) return;

    const measureAxis = chartProp.properties[propKey].chartAxes.find(
      (axis: any) => axis.name === AxisType.Measure,
    );

    if (!measureAxis?.fields?.length) return;

    // Check each measure field and convert Min/Max/Count Unique to Sum
    measureAxis.fields.forEach((field: any, index: number) => {
      const agg = field.agg;
      if (agg && (agg === 'min' || agg === 'max' || agg === 'countu')) {
        const field2 = JSON.parse(JSON.stringify(field));
        field2.agg = 'sum';

        // ----update display name ---//
        field2.displayname = fieldName(field2);
        const measureIndex = chartProp.properties[propKey].chartAxes.findIndex(
          (axis: any) => axis.name === AxisType.Measure,
        );

        //---update measure field---//
        dispatch(
          editChartPropItem('updateQuery', {
            propKey,
            binIndex: measureIndex,
            itemIndex: index,
            item: field2,
            currentChartAxesName,
          }),
        );
      }
    });
  }, [
    chartType,
    chartProp.properties[propKey]?.chartAxes?.find((axis: any) => axis.name === 'Split By')?.fields
      ?.length,
  ]);

  const selectedDs = chartProp.properties[propKey].selectedDs;

  // DropZoneDropItem
  const handleDrop = async (item: any, bIndex: number) => {
    const measureFields =
      chartProp.properties[propKey]?.chartAxes?.find((axis: any) => axis.name === 'Measure')
        ?.fields || [];
    // Calculate what the new first measure will be after the move
    const getNewFirstMeasureUId = () => {
      if (item.uId === measureFields[0]?.uId && measureFields[1]?.uId) {
        return measureFields[1].uId; // Second becomes first
      }
      return measureFields[0]?.uId;
    };

    
    let modifiedName = name;
    if (modifiedName === 'Filter' && uID) modifiedName = 'FilterOverride';
    if (!['Measure', 'X', 'Y', 'Filter'].includes(modifiedName) && item.isAggregated) {
      setSeverity('warning');
      setOpenAlert(true);
      setTestMessage("Can't drop aggregated calculations here");
      return;
    }

    const allowedNumbers = ChartsInfo[chartType].dropZones[bIndex].allowedNumbers;
    const dropZoneName = ChartsInfo[chartType].dropZones[bIndex].name;
    const dataType = item?.fieldData?.dataType ?? item?.dataType;

    if (dropZoneName === 'Location' && dataType !== 'text') {
      setSeverity('warning');
      setOpenAlert(true);
      setTestMessage('Only text fields are supported');
      return;
    }

    if (ChartsInfo[chartType].dropZones[bIndex].name === 'Location') {
      // on field change in location reset the unMatched array
      dispatch(changeGeoMapUnMatched(propKey, []));
    }

    console.log(item);
    // when column dragged from table i.e from Box.tsx
    let showSnackBar = false;
    const _uID = uIdGenerator();
    if (item.bIndex === 99) {
      /**
       * Column or row level saved calculation dragged from table dropped in area other than measure or chart filter
       */
      if (
        !uID &&
        // !['scatterPlot'].includes(chartType) &&
        ![Area.CHART_FILTER, Area.MEASURE].includes(name)
      ) {
        /**
         * DELETE all  window functions as there is a change in dimension  so all window function must be removed
         */
        const chartAxis = chartProp.properties[propKey]?.chartAxes;
        if (!chartAxis) return;

        const measures = getAllMeasureFieldsGroupBy();
        for (const [axisName, fields] of Object.entries(measures)) {
          let dropzoneInfo = ChartsInfo[chartType].dropZones.find(
            (dropzone: any) => dropzone.name === axisName,
          );
          if (dropzoneInfo?.allowedNumbers) {
            let newNotAllowednames: string[] = [];
            const modifiedMeasures = fields.map((field: any) => {
              if (!field.windowfn) return field;
              else {
                showSnackBar = true;
                if (field.isTextRenamed) return { ...field, windowfn: null };
                const newFieldData = setDisplayName(
                  setPrefix({ ...field, windowfn: null }, axisName, chartType),
                  axisName,
                  chartType,
                );
                newFieldData.displayname = findNewDisplayName(
                  chartProp.properties[propKey].chartAxes,
                  newFieldData,
                  chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
                  newNotAllowednames,
                );
                newNotAllowednames.push(newFieldData.displayname);
                return newFieldData;
              }
            });
            dispatch(setMeasureAxisFields(propKey, modifiedMeasures, axisName));
          }
        }
      }

      const fieldData = item.fieldData;
      fieldData.uId = _uID;
      // Adding original dataSetId and original tableId to the fieldData object to track the original dataset and table when switching datasets
      fieldData.originalDataSetId = selectedDs.id;
      fieldData.originalTableId = item.fieldData.tableId;

      // ----------------Add uId in checkedMeasure if it is from Measure, X Axis, Y Axis (Start)----------//
      if (
        ChartsInfo[chartType].dropZones[bIndex].name === 'Measure' ||
        ChartsInfo[chartType].dropZones[bIndex].name === 'X Axis' ||
        ChartsInfo[chartType].dropZones[bIndex].name === 'Y Axis' ||
        ChartsInfo[chartType].dropZones[bIndex].name === 'Date'
      ) {
        checkedMeasure.push(fieldData.uId);
        dispatch(updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', checkedMeasure));
      }
      //----------------------------------------(End)------------------------------------------------//
      deleteReplacedFieldSortConfig(bIndex, allowedNumbers);
      if (bIndex === 1) {
        if (chartType === 'calendar') {
          if (['date', 'timestamp', 'Date', 'Timestamp'].includes(fieldData.dataType)) {
            const newFieldData = setDisplayName(
              setPrefix(fieldData, name, chartType),
              name,
              chartType,
            );
            dispatch(
              editChartPropItem('update', {
                propKey,
                bIndex,
                item: newFieldData,
                allowedNumbers,
                currentChartAxesName,
              }),
            );
            //----If allowedNumbers is reached, the first field will be replaced, remove its uId from checkedMeasure---//
            const currentFields = currentChartAxes[bIndex]?.fields || [];
            if (currentFields.length >= allowedNumbers && currentFields[0]?.uId) {
              const tempCheckedMeasureList = [...checkedMeasure];
              const removedMeasureIndex = tempCheckedMeasureList.findIndex(
                (uId: string) => uId === currentFields[0].uId,
              );
              if (removedMeasureIndex !== -1) {
                tempCheckedMeasureList.splice(removedMeasureIndex, 1);
                dispatch(
                  updateFormatOption(
                    propKey,
                    'tooltipFormats',
                    'checkedMeasure',
                    tempCheckedMeasureList,
                  ),
                );
              }
            }
          } else {
            setSeverity('error');
            setOpenAlert(true);
            setTestMessage("Can't drop columns of datatype other than date or timestamp");
          }
        } else {
          const newFieldData = setDisplayName(
            setPrefix(fieldData, name, chartType),
            name,
            chartType,
          );
          newFieldData.displayname = findNewDisplayName(
            chartProp.properties[propKey].chartAxes,
            newFieldData,
            chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
          );
          if (chartType === 'richText') {
            dispatch(updateDynamicMeasureAxes(bIndex, allowedNumbers, newFieldData));
          } else {
            dispatch(
              editChartPropItem('update', {
                propKey,
                bIndex,
                item: newFieldData,
                allowedNumbers,
                currentChartAxesName,
                SavedCalculationUUID: item.boxUUID || null,
              }),
            );
            //----If allowedNumbers is reached, the first field will be replaced, remove its uId from checkedMeasure---//
            const currentFields = currentChartAxes[bIndex]?.fields || [];
            if (currentFields.length >= allowedNumbers && currentFields[0]?.uId) {
              const tempCheckedMeasureList = [...checkedMeasure];
              const removedMeasureIndex = tempCheckedMeasureList.findIndex(
                (uId: string) => uId === currentFields[0].uId,
              );
              if (removedMeasureIndex !== -1) {
                tempCheckedMeasureList.splice(removedMeasureIndex, 1);
                dispatch(
                  updateFormatOption(
                    propKey,
                    'tooltipFormats',
                    'checkedMeasure',
                    tempCheckedMeasureList,
                  ),
                );
              }
            }
          }
          //---Add measure uid in measureList when bIndex === 1 and it's a Measure axis (e.g., Simple Card, funnel chart, gauge chart.)---//
          if (
            [DropTo.X, DropTo.Y, DropTo.MEASURE, 'X', 'Y', 'Measure', 'X Axis', 'Y Axis'].includes(
              name,
            )
          ) {
            const currentFields = currentChartAxes[bIndex]?.fields || [];
            ['xAxis', 'yAxis'].forEach((axis) => {
              let seriesMeasureList = axisOptions[axis]['1'].measuresList || [];
              let updatedList = [...seriesMeasureList];
              if (currentFields.length >= allowedNumbers && currentFields[0]?.uId) {
                updatedList = updatedList.filter((uId: string) => uId !== currentFields[0].uId);
              }
              updatedList.push(fieldData.uId);
              dispatch(updateAxisOptions(propKey, axis, 'measuresList', updatedList, '1'));
            });
          }
          //-----------------------------------------------------------------------------------------------------------------//
        }
      }
      //bindex is not 1 (dimension)
      else {
        const newFieldData = setDisplayName(setPrefix(fieldData, name, chartType), name, chartType);
        newFieldData.displayname = findNewDisplayName(
          chartProp.properties[propKey].chartAxes,
          newFieldData,
          chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
        );

        if (chartType === 'richText') {
          dispatch(updateDynamicMeasureAxes(bIndex, allowedNumbers, newFieldData));
        } else {
          let measureAxis = ChartsInfo[chartProp.properties[propKey].chartType].dropZones.find(
            (zone) => zone.name === 'Measure' || zone.name === 'X Axis' || zone.name === 'Y Axis',
          );
          if (measureAxis?.allowedNumbers === 1) {
            dispatch(setOldChartType(propKey, chartProp.properties[propKey].chartType));
          }
          if (uID && name === 'Filter') {
            if (!newFieldData.includeexclude) newFieldData['includeexclude'] = 'Include';
            if (!newFieldData.exprInput) newFieldData['exprInput'] = '';

            if (newFieldData && newFieldData.dataType) {
              switch (newFieldData.dataType) {
                case 'decimal':
                case 'integer':
                  if (!newFieldData.fieldtypeoption) {
                    newFieldData['fieldtypeoption'] = 'Search Condition';
                  }
                  break;
                case 'date':
                case 'timestamp':
                  if (!newFieldData.fieldtypeoption) {
                    newFieldData['prefix'] = 'year';
                    newFieldData['fieldtypeoption'] = 'Pick List';
                  }
                  break;
                default:
                  if (!newFieldData.fieldtypeoption) {
                    newFieldData['fieldtypeoption'] = 'Pick List';
                  }
                  break;
              }
            }

            if (newFieldData.fieldtypeoption === 'Search Condition') {
              if (newFieldData.dataType) {
                switch (newFieldData.dataType) {
                  case 'decimal':
                  case 'integer':
                    if (!newFieldData.exprType) {
                      newFieldData['exprType'] = 'greaterThan';
                    }
                    break;
                  case 'text':
                    if (!newFieldData.exprType) {
                      newFieldData['exprType'] = 'beginsWith';
                    }
                    break;
                  case 'timestamp':
                  case 'date':
                    if (!newFieldData.exprType) {
                      newFieldData['prefix'] = 'year';
                      newFieldData['exprType'] = 'greaterThan';
                    }
                    break;
                  default:
                    if (!newFieldData.exprType) {
                      newFieldData['exprType'] = 'greaterThan';
                    }
                    break;
                }
              }
            }
          }
          dispatch(
            editChartPropItem('update', {
              propKey,
              bIndex,
              item: newFieldData,
              allowedNumbers,
              currentChartAxesName,
              SavedCalculationUUID: item.boxUUID || null,
              isParameterized: false,
            }),
          );
          //----If allowedNumbers is reached, the first field will be replaced, remove its uId from checkedMeasure---//
          const currentFields = currentChartAxes[bIndex]?.fields || [];
          if (currentFields.length >= allowedNumbers && currentFields[0]?.uId) {
            const tempCheckedMeasureList = [...checkedMeasure];
            const removedMeasureIndex = tempCheckedMeasureList.findIndex(
              (uId: string) => uId === currentFields[0].uId,
            );
            if (removedMeasureIndex !== -1) {
              tempCheckedMeasureList.splice(removedMeasureIndex, 1);
              dispatch(
                updateFormatOption(
                  propKey,
                  'tooltipFormats',
                  'checkedMeasure',
                  tempCheckedMeasureList,
                ),
              );
            }
          }
          //---by default add measure uid in measureList of a axis in first series as soon as we add new field(Only add for Measure, X, or Y axes) -----//
          if (
            [DropTo.X, DropTo.Y, DropTo.MEASURE, 'X', 'Y', 'Measure', 'X Axis', 'Y Axis'].includes(
              name,
            )
          ) {
            ['xAxis', 'yAxis'].forEach((axis) => {
              let seriesMeasureList = axisOptions[axis]['1'].measuresList || [];
              let updatedList = [...seriesMeasureList];
              //---If allowedNumbers is reached, the first field will be replaced, remove its uId from measuresList---//
              if (currentFields.length >= allowedNumbers && currentFields[0]?.uId) {
                updatedList = updatedList.filter((uId: string) => uId !== currentFields[0].uId);
              }
              updatedList.push(fieldData.uId);
              dispatch(updateAxisOptions(propKey, axis, 'measuresList', updatedList, '1'));
            });
          }
          //----------------------------------------------------------------------------------------------------------//
          if (name === 'Split By' && chartProp.properties[propKey].chartAxes[3].fields.length > 1) {
            const uID = uIdGenerator();
            // fallback for when item.fieldData is null because we are not dragging from table
            const fieldData = item.fieldData ?? {
              dataType: item.dataType,
              displayname: item.displayname,
              fieldname: item.fieldname,
              hasOverridedFlow: item.hasOverridedFlow ?? false,
              tableId: item.tableId,
              uId: '',
            };
            fieldData.uId = uID;

            const newFieldData = setDisplayName(
              setPrefix(fieldData, name, chartType),
              name,
              chartType,
            );
            newFieldData.displayname = findNewDisplayName(
              chartProp.properties[propKey].chartAxes,
              newFieldData,
            );

            dispatch(
              moveItemChartProp(
                propKey,
                item.bIndex,
                item.uId,
                newFieldData,
                bIndex,
                allowedNumbers,
                currentChartAxesName,
                item.boxUUID || null,
                true,
              ),
            );

            const formatObject = chartControls.properties?.[propKey]?.formatOptions
              ?.tooltipFormats || {
              measureFormats: {},
            };
            const newMeasureFormats = { ...(formatObject.measureFormats || {}) };

            const splitByFields =
              chartProp.properties?.[propKey]?.chartAxes?.[3]?.fields &&
                Array.isArray(chartProp.properties[propKey].chartAxes[3].fields)
                ? chartProp.properties[propKey].chartAxes[3].fields
                : [];

            let tempCheckedMeasure = [...checkedMeasure];
            if (splitByFields.length > 0) {
              splitByFields.forEach((field: any) => {
                if (field?.uId && tempCheckedMeasure.includes(field.uId)) {
                  tempCheckedMeasure = tempCheckedMeasure.filter((id: string) => id !== field.uId);
                  dispatch(
                    updateFormatOption(
                      propKey,
                      'tooltipFormats',
                      'checkedMeasure',
                      tempCheckedMeasure,
                    ),
                  );
                  if (newMeasureFormats[field.uId]) {
                    delete newMeasureFormats[field.uId];
                  }
                }
              });
              const firstMeasureUid = getNewFirstMeasureUId();
              if (!tempCheckedMeasure.includes(firstMeasureUid)) {
                tempCheckedMeasure.push(firstMeasureUid);
              }
            }
            dispatch(
              updateFormatOption(propKey, 'tooltipFormats', 'measureFormats', newMeasureFormats),
            );
            dispatch(
              updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', tempCheckedMeasure),
            );
          }

          if (
            [
              'line',
              'area',
              'stackedArea',
              'multibar',
              'stackedBar',
              'horizontalBar',
              'horizontalStacked',
            ].includes(chartType) &&
            name === 'Measure'
          ) {
            if (chartProp.properties[propKey].chartAxes?.[2]?.fields?.length > 0) {
              if (chartProp.properties[propKey].chartAxes?.[3]?.fields?.length >= 1) {
                //----Remove Split By field's uId from checkedMeasure before deleting it---//
                const splitByFieldToRemove = chartProp.properties[propKey].chartAxes[2].fields[0];
                if (
                  splitByFieldToRemove?.uId &&
                  checkedMeasure.includes(splitByFieldToRemove.uId)
                ) {
                  const updatedCheckedMeasure = checkedMeasure.filter(
                    (uId: string) => uId !== splitByFieldToRemove.uId,
                  );
                  dispatch(
                    updateFormatOption(
                      propKey,
                      'tooltipFormats',
                      'checkedMeasure',
                      updatedCheckedMeasure,
                    ),
                  );
                }

                // Removing the splitby field from sort config if available
                if (splitByFieldToRemove?.uId) {
                  const splitBySortConfigIndex = sortConfigurations.findIndex(
                    (config: SortConfiguration) => config.fieldId === splitByFieldToRemove.uId,
                  );
                  if (splitBySortConfigIndex !== -1) {
                    dispatch(deleteSortConfiguration(propKey, splitBySortConfigIndex));
                  }
                }
                dispatch(deleteItemInChartProp(propKey, 2, 0));
              }
            }
          }
        }
      }

      //---------------------clean up invalid sort configurations after field is added-------------------//
      // This handles cases where adding a field makes other sort configurations invalid
      if (sortConfigurations.length > 0) {
        // Create a updated state after the field is added
        const updatedChartAxes = chartProp.properties[propKey].chartAxes.map(
          (axis: any, axisIndex: number) => {

            // Add field to destination axis
            if (axisIndex === bIndex) {
              const currentFields = axis.fields || [];
              const allowedNumbers = ChartsInfo[chartType].dropZones[bIndex].allowedNumbers;

              // Update the field being added
              let newFields = [...currentFields];
              if (currentFields.length >= allowedNumbers) {
                newFields = [...currentFields.slice(1), item];
              } else {
                newFields = [...currentFields, item];
              }
              return {
                ...axis,
                fields: newFields,
              };
            }
            return axis;
          },
        );

        // Create temporary configs excluding the one we just deleted
        let tempConfigs = sortConfigurations.filter(
          (config: SortConfiguration) => config.fieldId !== item.uId,
        );

        // Check remaining configs
        for (let i = tempConfigs.length - 1; i >= 0; i--) {
          const config = tempConfigs[i];

          // Check if this config would be disabled after the field movement
          const isDisabled = handleCheckDisableField(
            config.fieldId,
            propKey,
            {
              properties: {
                [propKey]: {
                  ...chartProp.properties[propKey],
                  chartAxes: updatedChartAxes,
                },
              },
            },
            tempConfigs,
          );

          if (config.sortOrder !== '' && isDisabled) {
            // Find the actual index in the original sortConfigurations array
            const actualIndex = sortConfigurations.findIndex(
              (c: SortConfiguration) => c.id === config.id,
            );
            if (actualIndex !== -1) {
              dispatch(deleteSortConfiguration(propKey, actualIndex));
              tempConfigs = tempConfigs.filter((_: SortConfiguration, idx: number) => idx !== i);
            }
          }
        }
      }

    } else if (item.bIndex !== bIndex) {
      //--------delete sort configuration of moved field(when field is moved from one axis to another)-------//
      const movedFieldConfigIndex = sortConfigurations.findIndex(
        (config: SortConfiguration) => config.fieldId === item.uId,
      );
      if (movedFieldConfigIndex !== -1) {
        dispatch(deleteSortConfiguration(propKey, movedFieldConfigIndex));
      }

      //---------------------clean up invalid sort configurations after field movement-------------------//
      // This handles cases where moving this field makes other sort configurations invalid
      if (sortConfigurations.length > 0) {
        // Create a updated state after the field is moved
        const updatedChartAxes = chartProp.properties[propKey].chartAxes.map(
          (axis: any, axisIndex: number) => {
            // Remove field from source axis
            if (axisIndex === item.bIndex) {
              return {
                ...axis,
                fields: axis.fields.filter((field: any) => field.uId !== item.uId),
              };
            }
            // Add field to destination axis
            if (axisIndex === bIndex) {
              const currentFields = axis.fields || [];
              const allowedNumbers = ChartsInfo[chartType].dropZones[bIndex].allowedNumbers;

              // Update the field being added
              let newFields = [...currentFields];
              if (currentFields.length >= allowedNumbers) {
                newFields = [...currentFields.slice(1), item];
              } else {
                newFields = [...currentFields, item];
              }
              return {
                ...axis,
                fields: newFields,
              };
            }
            return axis;
          },
        );

        // Create temporary configs excluding the one we just deleted
        let tempConfigs = sortConfigurations.filter(
          (config: SortConfiguration) => config.fieldId !== item.uId,
        );

        // Check remaining configs
        for (let i = tempConfigs.length - 1; i >= 0; i--) {
          const config = tempConfigs[i];

          // Check if this config would be disabled after the field movement
          const isDisabled = handleCheckDisableField(
            config.fieldId,
            propKey,
            {
              properties: {
                [propKey]: {
                  ...chartProp.properties[propKey],
                  chartAxes: updatedChartAxes,
                },
              },
            },
            tempConfigs,
          );

          if (config.sortOrder !== '' && isDisabled) {
            // Find the actual index in the original sortConfigurations array
            const actualIndex = sortConfigurations.findIndex(
              (c: SortConfiguration) => c.id === config.id,
            );
            if (actualIndex !== -1) {
              dispatch(deleteSortConfiguration(propKey, actualIndex));
              tempConfigs = tempConfigs.filter((_: SortConfiguration, idx: number) => idx !== i);
            }
          }
        }
      }

      // Initialize filter properties when dropping to filter override
      if (uID && name === 'Filter') {
        if (!item.includeexclude) item['includeexclude'] = 'Include';
        if (!item.exprInput) item['exprInput'] = '';

        if (item && item.dataType) {
          switch (item.dataType) {
            case 'decimal':
            case 'integer':
              if (!item.fieldtypeoption) {
                item['fieldtypeoption'] = 'Search Condition';
              }
              break;
            case 'date':
            case 'timestamp':
              if (!item.fieldtypeoption) {
                item['prefix'] = 'year';
                item['fieldtypeoption'] = 'Pick List';
              }
              break;
            default:
              if (!item.fieldtypeoption) {
                item['fieldtypeoption'] = 'Pick List';
              }
              break;
          }
        }

        if (item.fieldtypeoption === 'Search Condition') {
          if (item.dataType) {
            switch (item.dataType) {
              case 'decimal':
              case 'integer':
                if (!item.exprType) {
                  item['exprType'] = 'greaterThan';
                }
                break;
              case 'text':
                if (!item.exprType) {
                  item['exprType'] = 'beginsWith';
                }
                break;
              case 'timestamp':
              case 'date':
                if (!item.exprType) {
                  item['prefix'] = 'year';
                  item['exprType'] = 'greaterThan';
                }
                break;
              default:
                if (!item.exprType) {
                  item['exprType'] = 'greaterThan';
                }
                break;
            }
          }
        }
      }

      //if item is dragged from dimension/date/row/column to filter/distribution/splitby then remove checked measure
      // format in Date axis is not allowed for label but allowed for tooltip
      const dimensionAxisList = ['Dimension', 'Row', 'column', 'Date', 'Split By'];
      const formattingNotAllowedAxisList = ['Filter', 'Distribution'];
      if (
        item.timeGrain === 'date' &&
        dimensionAxisList.includes(item.dragFrom) &&
        formattingNotAllowedAxisList.includes(name)
      ) {
        const updatedCheckedMeasure = checkedMeasure.filter((uId: string) => uId !== item.uId);
        dispatch(
          updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', updatedCheckedMeasure),
        );
      }
      //-------------------------------------------------------------------------------------------------//
      /**
       * if drop item into row. col.dimension, x, y,  from any other chart axis or (drop in measure but  item is not dragged from chart filter) or(drop in chart filter but item is not dragged from measure)
       */
      if (
        !uID &&
        ([
          DropTo.COLUMN,
          DropTo.DIMENSION,
          DropTo.ROW,
          DropTo.X,
          DropTo.Y,
          DropTo.SPLIT_BY,
          DropTo.LOCATION,
        ].includes(name) ||
          (name === AxisType.Measure && item.dragFrom !== Area.CHART_FILTER) ||
          (DropTo.CHART_FILTER === name && item.dragFrom !== Area.MEASURE))
      ) {
        const chartAxis = chartProp.properties[propKey]?.chartAxes;
        if (!chartAxis) return;
        deleteReplacedFieldSortConfig(bIndex, allowedNumbers);

        const measures = getAllMeasureFieldsGroupBy();
        for (const [axisName, fields] of Object.entries(measures)) {
          let dropzoneInfo = ChartsInfo[chartType].dropZones.find(
            (dropzone: any) => dropzone.name === axisName,
          );
          if (dropzoneInfo?.allowedNumbers) {
            let newNotAllowednames: string[] = [];
            const modifiedMeasures = fields.map((field: any) => {
              if (!field.windowfn) return field;
              else {
                showSnackBar = true;
                if (field.isTextRenamed) return { ...field, windowfn: null };
                const newFieldData = setDisplayName(
                  setPrefix({ ...field, windowfn: null }, axisName, chartType),
                  axisName,
                  chartType,
                );
                newFieldData.displayname = findNewDisplayName(
                  chartProp.properties[propKey].chartAxes,
                  newFieldData,
                  chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
                  newNotAllowednames,
                );
                newNotAllowednames.push(newFieldData.displayname);
                return newFieldData;
              }
            });
            dispatch(setMeasureAxisFields(propKey, modifiedMeasures, axisName));
          }
        }
      }
      //---Remove item.uId from measuresList if field is moving OUT of measure axis to any other axis---//
      if (![DropTo.X, DropTo.Y, DropTo.MEASURE].includes(name)) {
        if ([DropTo.X, DropTo.Y, DropTo.MEASURE, 'X', 'Y', 'Measure'].includes(item.dragFrom)) {
          ['xAxis', 'yAxis'].forEach((axis) => {
            let seriesMeasureList = axisOptions[axis]['1'].measuresList || [];
            let updatedList = seriesMeasureList.filter((uId: string) => uId !== item.uId);
            dispatch(updateAxisOptions(propKey, axis, 'measuresList', updatedList, '1'));
          });

          //---Remove item.uId from checkedMeasure if field is moving OUT of measure axis to any other axis---//
          if (checkedMeasure.includes(item.uId)) {
            const updatedCheckedMeasure = checkedMeasure.filter((uId: string) => uId !== item.uId);
            dispatch(
              updateFormatOption(
                propKey,
                'tooltipFormats',
                'checkedMeasure',
                updatedCheckedMeasure,
              ),
            );
          }

          ['tooltipFormats', 'labelFormats'].forEach((formatName) => {
            const measureFormats =
              chartControls.properties?.[propKey]?.formatOptions?.[formatName]?.measureFormats;
            let tempMeasureFormats = { ...measureFormats };
            if (Object.keys(tempMeasureFormats).includes(item.uId)) {
              delete tempMeasureFormats[item.uId];
              dispatch(
                updateFormatOption(propKey, formatName, 'measureFormats', tempMeasureFormats),
              );
            }
          });
        }
        //----------------------------------------------------------------------------------------------//
        deleteReplacedFieldSortConfig(bIndex, allowedNumbers);
        if (chartType === 'calendar') {
          if (item.dataType === 'date') {
            const newFieldData = setDisplayName(setPrefix(item, name, chartType), name, chartType);
            ['type', 'bIndex', 'agg'].forEach((e) => delete newFieldData[e]);
            dispatch(
              editChartPropItem('move', {
                propKey,
                fromBIndex: item.bIndex,
                fromUID: item.uId,
                item: newFieldData,
                toBIndex: bIndex,
                allowedNumbers,
                currentChartAxesName,
              }),
            );
          } else {
            setSeverity('error');
            setOpenAlert(true);
            setTestMessage("Can't drop columns of datatype other than date or timestamp");
          }
        } else {
          Logger('info', '******', name);
          let newFieldData = setDisplayName(setPrefix(item, name, chartType), name, chartType);
          newFieldData.displayname = findNewDisplayName(
            chartProp.properties[propKey].chartAxes,
            newFieldData,
            chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
          );
          if (![DropTo.X, DropTo.Y, DropTo.MEASURE, 'X', 'Y'].includes(item.dragFrom)) {
            newFieldData = JSON.parse(JSON.stringify(item));
          }
          ['type', 'bIndex'].forEach((e) => delete newFieldData[e]);

          /** if drag from x ,y,measure and drop into x,y or measure keep agg else delete */
          if (
            ![AxisType.X, AxisType.Y, AxisType.Measure].includes(item.dragFrom) ||
            ![AxisType.X, AxisType.Y, AxisType.Measure].includes(item.name)
          ) {
            delete newFieldData['agg'];
          }
          if (chartType === 'richText') {
            dispatch(
              editChartPropItemForDm('move', {
                propKey: `${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`,
                fromBIndex: item.bIndex,
                fromUID: item.uId,
                item: newFieldData,
                toBIndex: bIndex,
                allowedNumbers,
                currentChartAxesName,
              }),
            );
          } else {
            if (chartType === 'simplecard') {
              dispatch(addOrEditSimplecardConditionalFormat(propKey, []));
            }
            //----if item uId is same as columnId in cond.Format then remove its formatting, if dropped into another axis ---//
            if (
              (chartType === 'crossTab' || chartType === 'table') &&
              chartControls.properties[propKey]?.tableConditionalFormats?.length > 0
            ) {
              const index = chartControls.properties[propKey].tableConditionalFormats.findIndex(
                (format: any) => format.columnId === item.uId,
              );
              if (index !== -1) dispatch(deleteTablecf(propKey, index));
            }
            //------------------------------------------------------------------------------------//
            dispatch(
              editChartPropItem('move', {
                propKey,
                fromBIndex: item.bIndex,
                fromUID: item.uId,
                item: newFieldData,
                toBIndex: bIndex,
                allowedNumbers,
                currentChartAxesName,
                SavedCalculationUUID: item.SavedCalculationUUID,
              }),
            );
          }
        }
      }
      //bindex is not 1 (dimension)
      else {
        //-------Handle measuresList updates when moving to a measure axis-----//
        const currentFields = currentChartAxes[bIndex]?.fields || [];
        const isFromMeasureAxis = [
          DropTo.X,
          DropTo.Y,
          DropTo.MEASURE,
          'X',
          'Y',
          'Measure',
        ].includes(item.dragFrom);
        const willReplaceField = currentFields.length >= allowedNumbers && currentFields[0]?.uId;

        deleteReplacedFieldSortConfig(bIndex, allowedNumbers);

        ['xAxis', 'yAxis'].forEach((axis) => {
          let seriesMeasureList = axisOptions[axis]['1'].measuresList || [];
          let updatedList = [...seriesMeasureList];

          //---If allowedNumbers is reached, the first field will be replaced, remove its uId from measuresList---//
          if (willReplaceField) {
            updatedList = updatedList.filter((uId: string) => uId !== currentFields[0].uId);
          }

          //---Only add if field is NOT coming from a measure axis (measure to measure move doesn't need to add)---//
          if (!isFromMeasureAxis) {
            updatedList.push(item.uId);
          }

          dispatch(updateAxisOptions(propKey, axis, 'measuresList', updatedList, '1'));
        });
        //----If allowedNumbers is reached, the first field will be replaced, remove its uId from checkedMeasure and add new field's uId---//
        if (willReplaceField) {
          let tempCheckedMeasureList = checkedMeasure.filter(
            (uId: string) => uId !== currentFields[0].uId,
          );
          // Add the new field's uId if not already present
          if (item.uId && !tempCheckedMeasureList.includes(item.uId)) {
            tempCheckedMeasureList.push(item.uId);
          }
          dispatch(
            updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', tempCheckedMeasureList),
          );
        }
        //-----------------------------------------------------------------------------------------------------------//
        const newFieldData = setDisplayName(setPrefix(item, name, chartType), name, chartType);
        newFieldData.displayname = findNewDisplayName(
          chartProp.properties[propKey].chartAxes,
          newFieldData,
          chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats,
        );
        ['type', 'bIndex'].forEach((e) => delete newFieldData[e]);
        if (chartType === 'richText') {
          dispatch(
            editChartPropItemForDm('move', {
              propKey: `${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`,
              fromBIndex: item.bIndex,
              fromUID: item.uId,
              item: newFieldData,
              toBIndex: bIndex,
              allowedNumbers,
              currentChartAxesName,
            }),
          );
        } else {
          const tempXData = currentChartAxes.find((axis: any) => axis.name === 'X Axis');
          const tempYData = currentChartAxes.find((axis: any) => axis.name === 'Y Axis');
          if (chartType === 'scatterPlot' && newFieldData.SavedCalculationUUID) {
            const itemToMove = item.bIndex === 2 ? tempXData.fields[0] : tempYData.fields[0];
            if (itemToMove.override) {
              itemToMove.override = null;
            }
            dispatch(
              editChartPropItem('move', {
                propKey,
                fromBIndex: item.bIndex,
                fromUID: item.uId,
                item: itemToMove,
                toBIndex: bIndex,
                allowedNumbers,
                currentChartAxesName,
                SavedCalculationUUID: item.SavedCalculationUUID,
              }),
            );
          } else {
            if (
              [
                'line',
                'area',
                'stackedArea',
                'multibar',
                'stackedBar',
                'horizontalBar',
                'horizontalStacked',
              ].includes(chartType) &&
              name === 'Measure'
            ) {
              if (chartProp.properties[propKey].chartAxes?.[2]?.fields?.length > 0) {
                if (chartProp.properties[propKey].chartAxes?.[3]?.fields?.length >= 1) {
                  //----Remove Split By field's uId from checkedMeasure before deleting it---//
                  const splitByFieldToRemove = chartProp.properties[propKey].chartAxes[2].fields[0];
                  if (
                    splitByFieldToRemove?.uId &&
                    checkedMeasure.includes(splitByFieldToRemove.uId)
                  ) {
                    const updatedCheckedMeasure = checkedMeasure.filter(
                      (uId: string) => uId !== splitByFieldToRemove.uId,
                    );
                    dispatch(
                      updateFormatOption(
                        propKey,
                        'tooltipFormats',
                        'checkedMeasure',
                        updatedCheckedMeasure,
                      ),
                    );
                  }

                  // Removing the splitby field from sort config if available
                  if (splitByFieldToRemove?.uId) {
                    const splitBySortConfigIndex = sortConfigurations.findIndex(
                      (config: SortConfiguration) => config.fieldId === splitByFieldToRemove.uId,
                    );
                    if (splitBySortConfigIndex !== -1) {
                      dispatch(deleteSortConfiguration(propKey, splitBySortConfigIndex));
                    }
                  }
                  dispatch(deleteItemInChartProp(propKey, 2, 0));
                }
              }
            }

            //----if item uId is same as columnId in cond.Format then remove its formatting, if dropped into another axis ---//
            if (
              (chartType === 'crossTab' || chartType === 'table') &&
              chartControls.properties[propKey]?.tableConditionalFormats?.length > 0
            ) {
              const index = chartControls.properties[propKey].tableConditionalFormats.findIndex(
                (format: any) => format.columnId === item.uId,
              );
              if (index !== -1) dispatch(deleteTablecf(propKey, index));
            }
            //-----------------------------------------------------------------------------------------//
            dispatch(
              editChartPropItem('move', {
                propKey,
                fromBIndex: item.bIndex,
                fromUID: item.uId,
                item: newFieldData,
                toBIndex: bIndex,
                allowedNumbers,
                currentChartAxesName,
                SavedCalculationUUID: item.SavedCalculationUUID,
              }),
            );
          }
        }

        if (['Measure', 'X', 'Y', 'X Axis', 'Y Axis'].includes(name)) {
          // Only add if we haven't already handled it in the willReplaceField block above
          if (!willReplaceField && item.uId && !checkedMeasure.includes(item.uId)) {
            let tempCheckedMeasure = [...checkedMeasure];
            tempCheckedMeasure.push(item.uId);
            dispatch(
              updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', tempCheckedMeasure),
            );
          }
        }
      }
    }

    if (name === 'Split By' && chartProp.properties[propKey].chartAxes[3].fields.length > 1) {
      const uID = uIdGenerator();
      // fallback for when item.fieldData is null because we are not dragging from table
      const fieldData = item.fieldData ?? {
        dataType: item.dataType,
        displayname: item.displayname,
        fieldname: item.fieldname,
        hasOverridedFlow: item.hasOverridedFlow ?? false,
        tableId: item.tableId,
        uId: '',
      };
      fieldData.uId = uID;

      const newFieldData = setDisplayName(setPrefix(fieldData, name, chartType), name, chartType);
      newFieldData.displayname = findNewDisplayName(
        chartProp.properties[propKey].chartAxes,
        newFieldData,
      );

      dispatch(callQueryAPI(propKey, true));
      // To check if its draged from measures not need to move the last from measure if there is only 2 fields in measures
      if (
        chartProp.properties[propKey].chartAxes[3].fields.length >= 2 &&
        (chartProp.properties[propKey].chartAxes[3].fields.length > 2 ||
          !(
            item.dragFrom === DropTo.MEASURE &&
            chartProp.properties[propKey].chartAxes[3].fields.find(
              (field: any) => field.fieldname === item.fieldname,
            )
          ))
      ) {
        dispatch(
          moveItemChartProp(
            propKey,
            item.bIndex,
            item.uId,
            newFieldData,
            bIndex,
            allowedNumbers,
            currentChartAxesName,
            item.boxUUID || null,
            true,
          ),
        );
      }

      const formatObject = chartControls.properties?.[propKey]?.formatOptions?.tooltipFormats || {
        measureFormats: {},
      };
      const newMeasureFormats = { ...(formatObject.measureFormats || {}) };

      const splitByFields =
        chartProp.properties?.[propKey]?.chartAxes?.[3]?.fields &&
          Array.isArray(chartProp.properties[propKey].chartAxes[3].fields)
          ? chartProp.properties[propKey].chartAxes[3].fields
          : [];
      let tempCheckedMeasure = [...checkedMeasure];
      if (splitByFields.length > 0) {
        splitByFields.forEach((field: any) => {
          if (field?.uId && tempCheckedMeasure.includes(field.uId)) {
            tempCheckedMeasure = tempCheckedMeasure.filter((id: string) => id !== field.uId);
            if (newMeasureFormats[field.uId]) {
              delete newMeasureFormats[field.uId];
            }
          }
        });
      }
      const firstMeasureUid = getNewFirstMeasureUId();
      if (!tempCheckedMeasure.includes(firstMeasureUid)) {
        tempCheckedMeasure.push(firstMeasureUid);
      }
      dispatch(updateFormatOption(propKey, 'tooltipFormats', 'measureFormats', newMeasureFormats));
      dispatch(updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', tempCheckedMeasure));
    }
    /**
     * uID means its a override drop zone
     */
    dispatch(SetModifyOptions(propKey, uID ? 'filter_override_open' : 'axis', null));
    if (showSnackBar) {
      setShowPopup(true);
    }
    if ((name !== 'Filter' || item.dragFrom !== 'Table') && item.bIndex !== bIndex) {
      dispatch(callQueryAPI(propKey, true));
    }
  };

  const canDropField = (item: any) => {
    const isOverrideDropZone = Boolean(uID);

    const fromOverride = item?.dragFrom?.toLowerCase()?.includes("override");
    const fromMainAxis =
      !fromOverride && item?.dragFrom !== "Table" && item?.bIndex !== 99;

    // Block Override → Main
    if (!isOverrideDropZone && fromOverride) return false;

    //  Block Main → Override
    if (isOverrideDropZone && fromMainAxis) return false;

    //  Block Override → Override
    if (isOverrideDropZone && fromOverride && item?.overrideUId !== uID) return false;

    // Allow if item is from table
    return true;
  };

  const [{ isOver }, drop] = useDrop({
    accept: ['card', 'calculation'],
    hover: (item: any, monitor) => {
      if (!canDropField(item)) return;
      if (monitor.isOver({ shallow: true }) && !showBorder) {
        setShowBorder(true);
      }
    },
    canDrop: (item) => canDropField(item),
    drop: (item, monitor) => {
      if (!canDropField(item)) {
        monitor.getItem().dropEffect = "none";
        return;
      }
      handleDrop(item, bIndex);
      setShowBorder(false);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  // // Delete the field from Split by if Measure is greater than 1 fields
  // useEffect(() => {
  //   if (
  //     [
  //       'line',
  //       'area',
  //       'stackedArea',
  //       'multibar',
  //       'stackedBar',
  //       'horizontalBar',
  //       'horizontalStacked',
  //     ].includes(chartType)
  //   ) {
  //     if (!chartProp.properties[propKey]?.chartAxes?.[2]?.fields?.length) return;
  //     if (!chartProp.properties[propKey]?.chartAxes?.[3]?.fields?.length) return;

  useEffect(() => {
    if (!isOver) {
      setShowBorder(false);
    }
  }, [isOver]);

  useEffect(() => {
    updateRollUp();
  }, [chatAxesFieldsLength, chartProp.properties[propKey].enableOverrideForUID]);

  useEffect(() => {
    const axes = chartProp.properties[propKey].chartAxes || [];
    const measureAxes = axes.filter(
      (ax: any) => ax && (ax.name === 'Measure' || ax.name === 'X Axis' || ax.name === 'Y Axis'),
    );
    if (!measureAxes.length) return;

    const measureFields = measureAxes.flatMap((axis: any) => axis?.fields || []);

    const dimensionAxes = axes.filter(
      (ax: any) =>
        ax &&
        (ax.name === 'Row' ||
          ax.name === 'Column' ||
          ax.name === 'Dimension' ||
          ax.name === 'Date' ||
          ax.name === 'Split By'),
    );
    const dateFieldsFromDimensions = dimensionAxes.flatMap((axis: any) =>
      (axis?.fields || []).filter((field: any) => field.timeGrain === 'date'),
    );
    const derivedMeasureFields = [...measureFields, ...dateFieldsFromDimensions];

    if (!derivedMeasureFields.length) return;

    const currentFormats =
      chartControls.properties[propKey]?.formatOptions?.labelFormats?.measureFormats || {};
    const tooltipCurrentFormats =
      chartControls.properties[propKey]?.formatOptions?.tooltipFormats?.measureFormats || {};

    const measureTracker: any = {};
    let dimensionDateFieldUidList: string[] = [];
    dateFieldsFromDimensions.forEach((field: any) => dimensionDateFieldUidList.push(field.uId));

    derivedMeasureFields.forEach((field: any) => {
      const isDate = field.timeGrain === 'date' && dimensionDateFieldUidList.includes(field.uId);
      const existing = currentFormats[field.uId];

      if (existing && Object.keys(existing).length > 0) {
        measureTracker[field.uId] = { ...existing };
        return;
      }
      const defaultRoundingDigits = getRoundingDigits(field);
      if (isDate) {
        measureTracker[field.uId] = {
          formatValue: 'Date',
          finalDateFormat: existing?.finalDateFormat ?? '',
          selectedMeasureFormat: field.displayname,
        };
      } else {
        const validNumberFormat =
          existing?.formatValue && existing.formatValue !== 'Date'
            ? existing.formatValue
            : 'Number';
        measureTracker[field.uId] = {
          formatValue: validNumberFormat,
          currencySymbol: existing?.currencySymbol ?? '$',
          enableRounding: existing?.enableRounding ?? true,
          roundingDigits: existing?.roundingDigits ?? defaultRoundingDigits,
          numberSeparator: existing?.numberSeparator ?? 'Abbrev',
          percentageCalculate: existing?.percentageCalculate ?? false,
        };
      }
    });

    //for Tooltip
    const extraMeasureFields =
      chartControls.properties[propKey]?.formatOptions.tooltipFormats?.extraMeasureField[0]
        ?.fields ?? [];
    const tooltipMeasureTracker: any = {};
    const allMeasureFieldsForTooltip = [...derivedMeasureFields, ...extraMeasureFields];
    allMeasureFieldsForTooltip.forEach((field: any) => {
      // date axis in calendar chart has no agg
      const calendarWithDateAxis =
        chartType === 'calendar' && field.timeGrain === 'date' && !field.agg;
      const isDate =
        (field.timeGrain === 'date' && dimensionDateFieldUidList.includes(field.uId)) ||
        calendarWithDateAxis;
      const existing = tooltipCurrentFormats[field.uId];
      if (existing && Object.keys(existing).length > 0) {
        tooltipMeasureTracker[field.uId] = { ...existing };
        return;
      }

      const defaultRoundingDigits = getRoundingDigits(field);
      if (isDate) {
        tooltipMeasureTracker[field.uId] = {
          formatValue: 'Date',
          finalDateFormat: existing?.finalDateFormat ?? '',
          selectedMeasureFormat: field.displayname,
        };
      } else {
        const validNumberFormat =
          existing?.formatValue && existing.formatValue !== 'Date'
            ? existing.formatValue
            : 'Number';
        tooltipMeasureTracker[field.uId] = {
          formatValue: validNumberFormat,
          currencySymbol: existing?.currencySymbol ?? '$',
          enableRounding: existing?.enableRounding ?? true,
          roundingDigits: existing?.roundingDigits ?? defaultRoundingDigits,
          numberSeparator: existing?.numberSeparator ?? 'Abbrev',
          percentageCalculate: existing?.percentageCalculate ?? false,
        };
      }
    });
    // Only update if there are changes

    //for label

    if (JSON.stringify(measureTracker) !== JSON.stringify(currentFormats)) {
      dispatch(updateFormatOption(propKey, 'labelFormats', 'measureFormats', measureTracker));
      if (measureFields.length > 0) {
        dispatch(
          updateFormatOption(propKey, 'labelFormats', 'selectedMeasure', {
            name: measureFields[0].displayname,
            uId: measureFields[0].uId,
          } as any),
        );
      }
    }

    // for tooltip
    if (JSON.stringify(tooltipMeasureTracker) !== JSON.stringify(tooltipCurrentFormats)) {
      dispatch(
        updateFormatOption(propKey, 'tooltipFormats', 'measureFormats', tooltipMeasureTracker),
      );

      if (measureFields.length > 0) {
        dispatch(
          updateFormatOption(propKey, 'tooltipFormats', 'selectedMeasure', {
            name: measureFields[0].displayname,
            uId: measureFields[0].uId,
          } as any),
        );
      }
    }
  }, [chartProp.properties[propKey].chartAxes]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = async (closeFrom: any, queryParam?: any) => {
    setAnchorEl(null);

    if (closeFrom === 'opt1' && queryParam === 'Clear') {
      dispatch(clearDropZoneFieldsChartPropLeft(propKey, bIndex, currentChartAxesName));
    }
  };

  const RenderMenu = ({ name }: { name: string }) => {
    let options = ['Clear'];
    let options1: string[] = [];
    let options2: string[] = [];

    if (bIndex === 0) {
      options1 = ['All Conditions Met', 'Any Condition Met'];
      options2 = ['Auto Refresh', 'Manual Run'];
    } else {
      options1 = [];
    }

    return (
      <Menu
        key={name}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose('clickOutside')}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {options.length > 0
          ? options.map((opt, index) => {
            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  width: 'auto',
                  padding: '0.2rem 0.5rem 0.2rem 0',
                }}
                onClick={() => handleClose('opt1', opt)}
              >
                <span style={{ width: '2rem' }}></span>
                <MenuItem style={{ flex: 1, padding: 0, fontSize: '14px' }} key={index}>
                  {opt + ' ' + name}
                </MenuItem>
              </div>
            );
          })
          : null}
        <Divider />
        {bIndex === 0 && options1.length > 0
          ? options1.map((opt, index) => {
            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  width: 'auto',
                  padding: '0.2rem 0.5rem 0.2rem 0',
                }}
                onClick={() => {
                  setAnchorEl(null);
                  dispatch(
                    updateFilterAnyContidionMatchPropLeft(
                      propKey,
                      0,
                      !currentChartAxes[0].any_condition_match,
                      currentChartAxesName,
                    ),
                  );
                  dispatch(callQueryAPI(propKey, true));
                }}
              >
                <span style={{ width: '2rem', paddingLeft: '5px' }}>
                  <Radio
                    checked={
                      opt ===
                      (currentChartAxes[0].any_condition_match
                        ? 'Any Condition Met'
                        : 'All Conditions Met')
                    }
                    size="small"
                    style={{ padding: 0 }}
                  />
                </span>
                <MenuItem style={{ flex: 1, padding: 0, fontSize: '14px' }} key={index}>
                  {opt}
                </MenuItem>
              </div>
            );
          })
          : null}
        {/* <Divider /> */}
        {/* {bIndex === 0 && options2.length > 0
          ? options2.map((opt, index) => {
              return (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    width: 'auto',
                    padding: '0.2rem 0.5rem 0.2rem 0',
                  }}
                  onClick={() => {
                    setAnchorEl(null);
                    dispatch(
                      updateIsAutoFilterEnabledPropLeft(
                        propKey,
                        0,
                        !currentChartAxes[0].is_auto_filter_enabled,
                        currentChartAxesName,
                      ),
                    );
                  }}
                >
                  <span style={{ width: '2rem', paddingLeft: '5px' }}>
                    <Radio
                      checked={
                        opt ===
                        (currentChartAxes[0].is_auto_filter_enabled ? 'Auto Refresh' : 'Manual Run')
                      }
                      size="small"
                      style={{ padding: 0 }}
                    />
                  </span>
                  <MenuItem style={{ flex: 1, padding: 0, fontSize: '14px' }} key={index}>
                    {opt}
                  </MenuItem>
                </div>
              );
            })
          : null} */}
      </Menu>
    );
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  let minHeight = '3em';
  let displayStyle = 'flex';

  const dropSpaceEm = 2.5;

  const baseFontPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

  if (bIndex === 0) {
    minHeight = isFilterCollapsed ? 'auto' : minHeight;
    displayStyle = isFilterCollapsed ? 'none' : 'flex';
  }

  const fieldsCount = currentChartAxes[bIndex]?.fields.length || 0;
  const cardHeightPx = 24;
  const gapPx = 8;

  if (fieldsCount >= 1) {
    const totalCardsHeightPx = fieldsCount * cardHeightPx + (fieldsCount - 1) * gapPx;
    const dropSpacePx = dropSpaceEm * baseFontPx;
    const totalHeightPx = totalCardsHeightPx + dropSpacePx;
    // minHeight = `${totalHeightPx / baseFontPx}rem`;
    minHeight = isFilterCollapsed ? 'auto' : minHeight;
    displayStyle = 'flex';
  } else if (fieldsCount === 0) {
    minHeight = isFilterCollapsed ? 'auto' : minHeight;
    displayStyle = 'flex';
  }

  return (
    <>
      <div
        ref={drop}
        style={{
          flex: bIndex === 0 ? (isFilterCollapsed ? 'none' : 1) : 1,
        }}
        className={`chartAxis mt-2`}
      >
        <div
          style={{
            borderRight: 'none',
            overflow: 'hidden',
            // padding: '5px 0px 0px 2px',
            minHeight: isFilterCollapsed ? 'auto' : '3em',
            display: displayStyle,
          }}
          className="chartFilterGroupContainer"
        >
          <div
            style={{ border: '1px solid transparent', padding: '0 2px 0 2px' }}
            className={`axis-dropzone ${showBorder ? 'axis-dropzone-highlighted' : ''}`}
          >
            <div
              style={{
                display: 'flex',
              }}
              className="chartAxisHeader"
            >
              <div
                className="axisTitle"
                style={
                  name === 'Filter' && chartType !== 'geoChart'
                    ? {
                      flex: 1,
                      paddingBottom: '2px',
                      alignItems: 'center',
                      width: '100%',
                      display: 'flex',
                      color: theme.palette.primary.contrastText,
                      fontSize: fontSize.large,
                      marginTop: '6px',
                      gap: "5px"
                    }
                    : {
                      display: 'flex',
                      flex: 1,
                      padding: '5px 0 2px 0',
                      alignItems: 'center',
                      width: '100%',
                      color: theme.palette.primary.contrastText,
                      fontSize: fontSize.large,
                      gap : "5px"
                    }
                }
              >
                {name === 'Filter'
                  ? uID
                    ? <>
                      Filter Override
                      <Tooltip
                        title={<>Any filter added or removed here will override the chart filter for this particular measure.<br />
                          If you want to override report level filters, click "Ignore Report Filter" in particular measure's drop down menu. </>}
                        placement='top'
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px',
                            },
                          },
                        }}
                      >
                        <InfoOutlineSharpIcon fontSize="small" />
                      </Tooltip>
                    </>
                    : 'Chart Filter'
                  : uID
                    ? name === "Dimension" ? <>
                      Dimension Override
                      <Tooltip
                        title={`You can customize what dimensions affect this particular measure by adding/removing dimensions. "Roll-Up" option helps decide the level of depth.`}
                        placement='top'
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px',
                            },
                          },
                        }}
                      >
                        <InfoOutlineSharpIcon fontSize="small" />
                      </Tooltip>
                    </> : name + ' Override'
                    : name}
                {chartType === 'richText' ? (
                  <span  className="axisInfo">
                    ({selectedDynamicMeasureProps?.chartAxes[bIndex]?.fields?.length} of{' '}
                    {ChartsInfo[chartType].dropZones[bIndex]?.allowedNumbers})
                  </span>
                ) : (
                  <span className="axisInfo">
                    ({currentChartAxes[bIndex]?.fields.length} of{' '}
                    {ChartsInfo[chartType].dropZones[bIndex]?.allowedNumbers})
                  </span>
                )}

                {name === 'Filter' ? (
                  <DropZoneHeader
                    isFilterCollapsed={isFilterCollapsed}
                    setIsFilterCollapsed={setIsFilterCollapsed}
                    handleClick={handleClick}
                    bIndex={bIndex}
                    currentChartAxes={currentChartAxes}
                    propKey={propKey}
                    chartProp={chartProp}
                    toggleFilterRunState={(propKey: string, filterRunState: any) =>
                      dispatch(toggleFilterRunState(propKey, filterRunState))
                    }
                  />
                ) : null}
              </div>
            </div>
            <div
              className="chartAxisBody"
              style={{
                minHeight: minHeight,
                display: displayStyle,
                gap: '0.5rem',
                marginBottom: '20px',
              }}
            >
              {bIndex === 0 ? (
                <ChartFilterCards
                  isFilterCollapsed={isFilterCollapsed}
                  chartType={chartType}
                  selectedDynamicMeasureProps={selectedDynamicMeasureProps}
                  currentChartAxes={currentChartAxes}
                  bIndex={bIndex}
                  uID={uID}
                  name={name}
                  dynamicMeasureState={dynamicMeasureState}
                  propKey={propKey}
                />
              ) : (
                <ChartAxesCards
                  key={showBorder ? 'border' : 'no-border'} // to trigger re-render
                  chartType={chartType}
                  selectedDynamicMeasureProps={selectedDynamicMeasureProps}
                  currentChartAxes={currentChartAxes}
                  bIndex={bIndex}
                  uID={uID}
                  name={name}
                  dynamicMeasureState={dynamicMeasureState}
                  propKey={propKey}
                  tabTileProps={tabTileProps}
                  chartProp={chartProp}
                />
              )}
            </div>
          </div>
        </div>
        {name !== lastAxisName && (
          <Divider
            sx={{
              height: '2px',
              backgroundColor: 'rgba(224, 224, 224, 1)',
              border: 'none',
              margin: '3px 4px 3px 4px',
            }}
          />
        )}
        <NotificationDialog
          onCloseAlert={() => {
            setOpenAlert(false);
            setTestMessage('');
          }}
          severity={severity}
          testMessage={testMessage}
          openAlert={openAlert}
        />

        <RenderMenu name={ChartsInfo[chartType].dropZones[bIndex]?.name} />
        <SnackBar
          show={showPopup}
          message={messages.playbook.WindowFunctionRemoved}
          onClose={() => setShowPopup(false)}
        />
      </div>
    </>
  );
};

export default DropZone;
